import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TaskService {
  reloadTable$ = new BehaviorSubject(false);
  taskUrl = environment.baseApiUrl + 'task'

  constructor(
    private httpClient: HttpClient
  ) { }

  findAll(params?: any): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach((elem) => {
        Params = Params.append(elem.key, elem.val);
      });
    }
    
    return this.httpClient.get(this.taskUrl, {params: Params})
  }

  findOne(id: string): Observable<any> {
    return this.httpClient.get(`${this.taskUrl}/${id}`)
  }

  create(data: any): Observable<any> {
    return this.httpClient.post(`${this.taskUrl}`, data)
  }

  update(id: string, data: any): Observable<any> {
    return this.httpClient.put(`${this.taskUrl}/${id}`, data)
  }

  remove(id: string): Observable<any> {
    return this.httpClient.delete(`${this.taskUrl}/${id}`)
  }

  removeParent(id: string): Observable<any> {
    return this.httpClient.delete(`${this.taskUrl}/remove-parent/${id}`)
  }

  restore(id: string): Observable<any> {
    return this.httpClient.delete(`${this.taskUrl}/restore/${id}`)
  }

  getChartData(id: string, chartType: ChartType): Observable<any> {
    return this.httpClient.get(`${this.taskUrl}/chart/${id}/${chartType}`)
  }

  findProjectYearRange(): Observable<any> {
    return this.httpClient.get(`${this.taskUrl}/year-range`)
  }
}

export enum ChartType {
  cost = 'cost',
  time = 'time'
}